import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserIdentState {
  userId: string | null;
  firstName: string | null;
  lastName: string | null;
  loaded: boolean;
}

const initialState: UserIdentState = {
  userId: null,
  firstName: null,
  lastName: null,
  loaded: false,
};

const userSlice = createSlice({
  name: 'userIdent',
  initialState,
  reducers: {
    setUserIdent(state, action: PayloadAction<{ userId: string; firstName: string; lastName: string }>) {
      state.userId = action.payload.userId;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.loaded = true;
    },
    clearUserIdent(state) {
      state.userId = null;
      state.firstName = null;
      state.lastName = null;
      state.loaded = false;
    }
  }
});

export const { setUserIdent, clearUserIdent } = userSlice.actions;
export default userSlice.reducer; 